import {BaseContainerModel} from '../../base-container.model';
import { bl_cms_notification_hdr_RowClass } from '../../../dbschema/bl_cms_notification_hdr.model';

export class CmsNotificationContainerModel extends BaseContainerModel {
  bl_cms_notification_hdr: bl_cms_notification_hdr_RowClass = new bl_cms_notification_hdr_RowClass();
}